var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 471.3 500",
    style: {
      enableBackground: "new 0 0 471.3 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#103DAF;}\n\t.st1{fill:#5895FF;}\n\t.st2{fill:#FFFFFF;fill-opacity:0.4;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#1E49D3;enable-background:new    ;}\n\t.st5{fill:#043017;}\n\t.st6{fill:#157241;}\n\t.st7{fill:#34935F;}\n\t.st8{fill:#07542A;}\n\t.st9{fill:#BC3228;}\n\t.st10{fill:#F45B42;}\n\t.st11{fill:#CC493B;}\n\t.st12{fill:#F98073;}\n\t.st13{fill:#073551;}\n\t.st14{fill:#48A8FF;}\n\t.st15{fill:#2477B5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.4,268.5 82.1,230.3 82.1,268.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "472.7,268.5 391.9,230.3 391.9,268.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.8,2l163,166v273.9c0,32.1-25.5,58.1-57,58.1H90.3c-31.5,0-57-26-57-58.1V60.1C33.3,28,58.8,2,90.3,2 H277.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M440.7,168H337.7c-31.5,0-59.9-28.9-59.9-61V2L440.7,168z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M171.1,219.9L171.1,219.9c0,5.7-4.6,10.4-10.4,10.4H100c-5.7,0-10.4-4.6-10.4-10.4v0c0-5.7,4.6-10.4,10.4-10.4 h60.7C166.5,209.5,171.1,214.1,171.1,219.9z M252.6,178.4L252.6,178.4c0,5.7-4.6,10.4-10.4,10.4H100c-5.7,0-10.4-4.6-10.4-10.4v0 c0-5.7,4.6-10.4,10.4-10.4h142.2C247.9,168,252.6,172.7,252.6,178.4z M252.6,136.9L252.6,136.9c0,5.7-4.6,10.4-10.4,10.4H100 c-5.7,0-10.4-4.6-10.4-10.4v0c0-5.7,4.6-10.4,10.4-10.4h142.2C247.9,126.5,252.6,131.2,252.6,136.9z M252.6,95.4L252.6,95.4 c0,5.7-4.6,10.4-10.4,10.4H100c-5.7,0-10.4-4.6-10.4-10.4v0c0-5.7,4.6-10.4,10.4-10.4h142.2C247.9,85,252.6,89.7,252.6,95.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 268.5,
    className: "st4",
    width: 471.3,
    height: 156.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M166.1,311.4c6.3,3.2,11.1,7.8,14.6,13.8c3.4,6,5.1,12.9,5.1,20.8c0,7.9-1.7,14.8-5.1,20.7 c-3.4,5.9-8.3,10.5-14.6,13.7c-6.3,3.2-13.6,4.9-21.8,4.9h-27.6v-78.8h27.6C152.5,306.5,159.8,308.1,166.1,311.4z M162.8,365.1 c4.5-4.5,6.8-10.9,6.8-19.1c0-8.2-2.3-14.6-6.8-19.3c-4.5-4.6-10.9-6.9-19.2-6.9h-11.2v52.1h11.2 C151.9,371.9,158.3,369.6,162.8,365.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M213.9,380.9c-6.2-3.5-11.1-8.3-14.7-14.4c-3.6-6.1-5.4-13.1-5.4-20.8c0-7.7,1.8-14.6,5.4-20.7 c3.6-6.1,8.5-10.9,14.7-14.4c6.2-3.5,12.9-5.2,20.3-5.2c7.5,0,14.2,1.7,20.4,5.2c6.1,3.5,11,8.3,14.6,14.4 c3.6,6.1,5.4,13,5.4,20.7c0,7.8-1.8,14.7-5.4,20.8c-3.6,6.1-8.5,10.9-14.6,14.4c-6.2,3.5-12.9,5.2-20.3,5.2 C226.8,386.1,220,384.4,213.9,380.9z M246.7,368.8c3.6-2.1,6.4-5.2,8.5-9.2c2-4,3-8.6,3-13.9c0-5.3-1-9.9-3-13.8 c-2-4-4.9-7-8.5-9.1c-3.6-2.1-7.8-3.2-12.5-3.2c-4.7,0-8.9,1.1-12.6,3.2c-3.7,2.1-6.5,5.1-8.5,9.1c-2,4-3,8.6-3,13.8 c0,5.3,1,9.9,3,13.9c2,4,4.9,7.1,8.5,9.2c3.7,2.1,7.8,3.2,12.6,3.2C238.9,372,243.1,370.9,246.7,368.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M287.7,325c3.5-6.1,8.3-10.9,14.3-14.3c6.1-3.4,12.9-5.1,20.4-5.1c8.8,0,16.5,2.3,23.1,6.8 c6.6,4.5,11.3,10.8,13.9,18.7h-18.2c-1.8-3.8-4.3-6.6-7.6-8.5c-3.3-1.9-7.1-2.8-11.3-2.8c-4.6,0-8.7,1.1-12.3,3.2 c-3.6,2.1-6.4,5.2-8.4,9.1c-2,3.9-3,8.5-3,13.8c0,5.2,1,9.8,3,13.7c2,4,4.8,7,8.4,9.1c3.6,2.1,7.7,3.2,12.3,3.2 c4.3,0,8.1-1,11.3-2.9c3.3-1.9,5.8-4.8,7.6-8.5h18.2c-2.6,8.1-7.2,14.3-13.8,18.8c-6.6,4.5-14.3,6.7-23.2,6.7 c-7.5,0-14.3-1.7-20.4-5.1c-6.1-3.4-10.8-8.2-14.3-14.3c-3.5-6.1-5.3-13-5.3-20.8C282.4,338.1,284.2,331.1,287.7,325z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcDoc);
export default __webpack_public_path__ + "static/media/ac_doc.2a106afe4aece4aa29f377f01d59d03c.svg";
export { ForwardRef as ReactComponent };